import { useJsApiLoader } from '@react-google-maps/api';
import { GOOGLE_MAPS_MAP_ID } from '../../constants/lib/constants';

// Stable array so every useJsApiLoader call shares the same Loader options.
export const GOOGLE_MAPS_JS_API_MAP_IDS = [GOOGLE_MAPS_MAP_ID];

export const useShopGoogleMapsJsApiLoader = (googleMapsApiKey?: string) => {
  return useJsApiLoader({
    googleMapsApiKey: googleMapsApiKey || '',
    mapIds: GOOGLE_MAPS_JS_API_MAP_IDS,
  });
};
